module.exports = __webpack_public_path__ + "static/media/Project2_HeaderImg.07aa17a9.png";